import React from 'react';
import PropTypes from 'prop-types';

export default function TerrainTools(props) {
  return (
    <svg width={21} height={18} viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9.27 9.216L13 3L21 18H0L7 5L9.27 9.216ZM10.39 11.238L12.987 16H17.667L12.897 7.058L10.39 11.238ZM3.348 16H10.652L7 9.219L3.348 16ZM3.5 5C2.83696 5 2.20107 4.73661 1.73223 4.26777C1.26339 3.79893 1 3.16304 1 2.5C1 1.83696 1.26339 1.20107 1.73223 0.732233C2.20107 0.263392 2.83696 0 3.5 0C4.16304 0 4.79893 0.263392 5.26777 0.732233C5.73661 1.20107 6 1.83696 6 2.5C6 3.16304 5.73661 3.79893 5.26777 4.26777C4.79893 4.73661 4.16304 5 3.5 5Z" fill={props.color || '#000'} />
    </svg>
  );
}

TerrainTools.propTypes = {
  color: PropTypes.string
};
